import { Box, Text } from "@chakra-ui/react";
import useTranslation from "next-translate/useTranslation";
import CategoryListItem from "./CategoryListItem";

function TopicsTable({ topics }: any) {
  const { t } = useTranslation('common')
  return (
    <Box paddingTop="0">
      <Text
        className="small-title"
        fontWeight="700"
        fontSize="18px"
        mb="12px"
      >
        {t("article.topics.title")}
      </Text>
      {topics.map((item: any, index: number) => (
        <CategoryListItem key={index} item={item.attributes} />
      ))}
    </Box>
  );
}

export default TopicsTable;